import { Link } from 'react-router-dom';
import './CategorySection.css';
import prop1 from '../../assets/plots/plot2.jpg';
import prop2 from '../../assets/catogory/Apartments/img1.jpg';
import prop3 from '../../assets/catogory/agricultural/img1.jpg';
import prop4 from '../../assets/catogory/Individual_Villas/img1.jpg';
import prop5 from '../../assets/catogory/Residential_Plots/img1.jpg';

const CategorySection = () => {
    return (
        <section className="category-section">
            <div className="category-container">

                {/* Left Large Card - Commercial */}
                <Link to="/commercial-plots" className="category-large-card">
                    <img src={prop1} alt="Commercial Properties" className="category-img" />
                    <div className="category-overlay">
                        <div className="category-border-frame">
                            <h3 className="category-title">Commercial Properties</h3>
                        </div>
                    </div>
                </Link>

                {/* Right Grid - 4 Smaller Cards */}
                <div className="category-small-grid">
                    <Link to="/apartments" className="category-small-card">
                        <img src={prop2} alt="Residential" className="category-img" />
                        <div className="category-overlay">
                            <div className="category-border-frame">
                                <h3 className="category-title">Residential</h3>
                            </div>
                        </div>
                    </Link>
                    <Link to="/villas" className="category-small-card">
                        <img src={prop4} alt="Luxury Villas" className="category-img" />
                        <div className="category-overlay">
                            <div className="category-border-frame">
                                <h3 className="category-title">Luxury Villas</h3>
                            </div>
                        </div>
                    </Link>
                    <Link to="/residential-plots" className="category-small-card">
                        <img src={prop5} alt="Land & Plots" className="category-img" />
                        <div className="category-overlay">
                            <div className="category-border-frame">
                                <h3 className="category-title">Land & Plots</h3>
                            </div>
                        </div>
                    </Link>
                    <Link to="/agricultural-lands" className="category-small-card">
                        <img src={prop3} alt="Agricultural" className="category-img" />
                        <div className="category-overlay">
                            <div className="category-border-frame">
                                <h3 className="category-title">Agricultural</h3>
                            </div>
                        </div>
                    </Link>
                </div>

            </div>
        </section>
    );
};

export default CategorySection;
